// All dates are displayed in German time. Pinning the time zone (and locale) is
// required so the server (which may run in UTC) and the browser render identical
// strings — otherwise React throws hydration errors on SSR'd client components.
export const TIME_ZONE = "Europe/Berlin";

type DateInput = Date | string | number | null | undefined;

// "08.06.2026" by default; pass Intl options to add fields or change styles,
// e.g. formatDate(d, { hour: "2-digit", minute: "2-digit" }) → "08.06.2026, 22:00"
export function formatDate(val: DateInput, options?: Intl.DateTimeFormatOptions): string {
  if (!val) return "";
  return new Date(val as string).toLocaleDateString("de-DE", { timeZone: TIME_ZONE, day: "2-digit", month: "2-digit", year: "numeric", ...options });
}

// "08.06.2026, 22:00"
export function formatDateTimeShort(val: DateInput): string {
  return formatDate(val, { hour: "2-digit", minute: "2-digit" });
}

// "08.06.2026, 22:00 Uhr"
export function formatDateTime(val: DateInput): string {
  if (!val) return "";
  return `${formatDateTimeShort(val)} Uhr`;
}

// Strips seconds from MySQL TIME strings like "23:00:00" → "23:00"
export function formatTime(val: string | null | undefined): string {
  if (!val) return "";
  return val.slice(0, 5);
}
